import { render, staticRenderFns } from "./AuthorityToWithdraw.vue?vue&type=template&id=8494a226"
import script from "./AuthorityToWithdraw.vue?vue&type=script&lang=js"
export * from "./AuthorityToWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports